import { Edit, SimpleForm, TextInput, required, useEditContext } from "react-admin";
import { Navigate } from "react-router-dom";
import { GroupedPermissionsInput } from "./GroupedPermissionsInput";
import { EditToolbar } from "@components/EditToolbar";

const validateRequired = [required()];

const RoleEditForm = () => {
  const { record, isLoading } = useEditContext();

  // Redirect system roles to show page
  if (!isLoading && record?.systemName) {
    return <Navigate to={`/role/${record.id}/show`} replace />;
  }

  return (
    <SimpleForm warnWhenUnsavedChanges toolbar={<EditToolbar />}>
      <TextInput source="name" validate={validateRequired} fullWidth />
      <TextInput source="description" multiline rows={3} fullWidth />
      <GroupedPermissionsInput source="permissions" />
    </SimpleForm>
  );
};

export const RoleEdit = () => (
  <Edit mutationMode="pessimistic">
    <RoleEditForm />
  </Edit>
);
